import { createFileRoute } from '@tanstack/react-router';
import { CompanyDetail } from '@/components/companies/company-detail';

export const Route = createFileRoute(
  '/_auth/_side-layout/companies_/$companyId',
)({
  component: CompanyDetailPage,
});

function CompanyDetailPage() {
  const { companyId } = Route.useParams();
  return <CompanyDetail companyId={companyId} />;
}
